import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { Space } from 'antd';
import WorkingTimeInfo, { GaugeSizeTypes } from './WorkingTimeInfo';
import CapacityInfo from './CapacityInfo';
import { RouteDtoModelType } from '../../../store/mst/models';
import StopsInfo from './StopsInfo';
import DistanceInfo from './DistanceInfo';

export enum MiniRouteContainerType {
  DAY_TOTAL = 'day-total',
  CALENDAR = 'calendar',
  MAP = 'map',
  BREAKDOWN = 'breakdown',
  DROPDOWN = 'dropdown',
  OVERVIEW = 'overview',
  GANTT = 'gantt',
}

interface Props {
  route: RouteDtoModelType;
  large?: boolean;
  type?: MiniRouteContainerType;
}

export enum SolutionViolationTypes {
  OVERTIME = 'Overtime',
  CAPACITY = 'Capacity',
}

const StyledSpace = styled(Space)`
  width: 100%;
  justify-content: space-between;
  .item {
    align-items: center;
    display: flex;
  }
`;

const MiniRouteInfo: React.FC<Props> = ({ route, large, type }) => (
  <StyledSpace align="center">
    <StopsInfo type={type} totalStops={route.totalStopsCount} ordersCount={route.totalOrdersCount} gaugeSize={GaugeSizeTypes.MEDIUM} />
    <DistanceInfo type={type} unit={route.distanceUnit} totalDistance={route.totalDistance} gaugeSize={GaugeSizeTypes.MEDIUM} />
    <WorkingTimeInfo
      workingTime={route.workingTimeMinutes || 0}
      duration={route.constraints?.durationMinutes || undefined}
      percentWorkingTime={route.percentWorkingTime || 0}
      overtime={route.isOvertime}
      large={large}
      type={type}
      gaugeSize={GaugeSizeTypes.MEDIUM}
    />
    <CapacityInfo
      totalLoad={route.totalLoad || 0}
      capacity={route.totalCapacity || undefined}
      percentLoad={route.totalCapacity ? route.percentLoad || 0 : 0}
      overcapacity={route.isOverCapacity}
      large={large}
      type={type}
      gaugeSize={GaugeSizeTypes.MEDIUM}
    />
  </StyledSpace>
);
export default observer(MiniRouteInfo);
